import { defineStore } from 'pinia'

export const useMemberStore = defineStore({
  id: 'member',
  state: () => ({
    members:[
      {
        name: 'members.noah.name',
        position: 'members.noah.position',
        link: '/intro/members/noah',
        image: '/images/noah_profile.gif',
        banner: '/images/thumbnail/homepage/noah.png',
        icon: '💜',
        term: 'noah',
        id: 1,
      },
      {
        name: 'members.yejun.name',
        position: 'members.yejun.position',
        link: '/intro/members/yejun',
        image: '/images/yejun_profile.gif',
        banner: '/images/thumbnail/homepage/yejun.png',
        icon: '💙',
        term: 'yejun',
        id: 2,
      },
      {
        name: 'members.bamby.name',
        position: 'members.bamby.position',
        link: '/intro/members/bamby',
        image: '/images/bamby_profile.gif',
        banner: '/images/thumbnail/homepage/bamby.png',
        icon: '💗',
        term: 'bamby',
        id: 3,
      },
      {
        name: 'members.eunho.name',
        position: 'members.eunho.position',
        link: '/intro/members/eunho',
        image: '/images/eunho_profile.gif',
        banner: '/images/thumbnail/homepage/eunho.png',
        icon: '❤️',
        term: 'eunho',
        id: 4,
      },
      {
        name: 'members.hamin.name',
        position: 'members.hamin.position',
        link: '/intro/members/hamin',
        image: '/images/hamin_profile.gif',
        banner: '/images/thumbnail/homepage/hamin.png',
        icon: '🖤',
        term: 'hamin',
        id: 5,
      },
    ]
   }),
   getters: {
    getMembers: (state) => state.members,
  },
  actions: {}
})
